import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, setDoc, doc, getDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import "firebase/functions";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseApp = initializeApp({
  apiKey: "AIzaSyAQfxNylzNvyJ5Ic0GpPpwRrWm1ppW2pRQ",
  authDomain: "se77e-marketing.firebaseapp.com",
  projectId: "se77e-marketing",
  storageBucket: "se77e-marketing.appspot.com",
  messagingSenderId: "475292294545",
  appId: "1:475292294545:web:6874d06f132e2002c04e30",
});

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const stg = getStorage(firebaseApp);
export const analytics = getAnalytics(firebaseApp);
export const functions = getFunctions(firebaseApp);

export const getWhatsappLink = async () => {
  const docRef = doc(db, "config", "whatsapp");
  const docSnap = await getDoc(docRef);
  return docSnap.exists()
    ? docSnap.data().link
    : "https://api.whatsapp.com/send/?phone=556240519377&text=Ol%C3%A1%21+Entrei+em+contato+atrav%C3%A9s+do+site+e+tenho+interesse+em+contratar+os+servi%C3%A7os.+%28n%C3%A3o+apague+esta+mensagem%29&type=phone_number&app_absent=0";
};

export const whatsappLink = await getWhatsappLink(firebaseApp);

export const setWhatsappLink = async (newLink) => {
  await setDoc(doc(db, "config", "whatsapp"), {
    link: newLink,
    updatedAt: new Date(),
  });
};
